import type { UserListParams } from '@/userManagement/application/types';

export const USER_KEYS = {
  all: ['user-management', 'users'] as const,
  tabSummary: () => [...USER_KEYS.all, 'tab-summary'] as const,
  list: (params: UserListParams) => [...USER_KEYS.all, 'list', params] as const,
  detail: (crossUserId: string, username?: string) => [...USER_KEYS.all, 'detail', crossUserId, username ?? ''] as const,
  permissions: (crossUserId: string, databaseKey: string | undefined, username?: string) =>
    [...USER_KEYS.all, 'permissions', crossUserId, databaseKey ?? 'all', username ?? ''] as const,
  databases: (crossUserId: string, username?: string) => [...USER_KEYS.all, 'databases', crossUserId, username ?? ''] as const,
  databaseCatalog: () => [...USER_KEYS.all, 'database-catalog'] as const,
  /** TROC-211: scoped Users-tab database filter (`GET /databases?scope=usersTabFilter`). */
  databaseCatalogUsersTabFilter: () => [...USER_KEYS.all, 'database-catalog', 'usersTabFilter'] as const,
  /** TROC-363: Add User active catalog (`GET /databases?scope=activeCatalog`). */
  databaseCatalogActiveCatalog: () => [...USER_KEYS.all, 'database-catalog', 'activeCatalog'] as const
};
